import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getAdjustmentMB(params) {
	return client.get("api/ecommerce/stock-adjustment/data-adjustment-mb", {
		params: params,
	});
}

function getAdjustmentAllMB(params) {
	return client.get("api/ecommerce/stock-adjustment/data-adjustment-all-mb", {
		params: params,
	});
}

function getDetailSAMB(params) {
	return client.get("api/ecommerce/stock-adjustment/detail-adjustment-mb", {
		params: {
			code : params
		},
	});
}

function exportAdjustmentMB(params) {
	return client.get("api/ecommerce/stock-adjustment/export-adjustment", {
		params: params,
	});
}

function createAdjustmentMB(params) {
	return client.post("api/ecommerce/stock-adjustment/stock-adjustment-mb", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
    getAdjustmentMB,
    getAdjustmentAllMB,
    getDetailSAMB,
    exportAdjustmentMB,
	createAdjustmentMB
}